'use client';

import { useDecisions } from '../../hooks';
import { FeedbackButton, FeedbackSkeleton } from './components';
import { useMedalliaForm, useMedalliaFormV2 } from './hooks';

export function MedalliaFeedbackButton() {
    const isOneTrust = useDecisions('onetrust');
    const buttonConfigLegacy = useMedalliaForm({
        isActive: !isOneTrust,
    });
    const buttonConfigV2 = useMedalliaFormV2({
        isActive: isOneTrust,
    });

    const { formState, onOpen } = isOneTrust ? buttonConfigV2 : buttonConfigLegacy;

    if (formState === 'blocked') return null;
    if (formState === 'loading') return <FeedbackSkeleton />;

    return <FeedbackButton isError={formState === 'error'} onOpen={onOpen} />;
}
